import { LoadingContainer } from 'components/loadingContainer'
import { LocalSellingCart } from 'features/admin/Ticket'
import { useEventById } from 'hooks/admin/useEvents'
import { useParams } from 'react-router-dom'

export const LocalSellingCartPage = () => {
    const { eventId } = useParams()

    const { data: currentEvent, isLoading, error } = useEventById(eventId || '')

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <meta name="robots" content="noindex, nofollow" />
            {currentEvent && <LocalSellingCart currentEvent={currentEvent} />}
        </LoadingContainer>
    )
}
